import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import ReactDOM from 'react-dom';
import { StyledEngineProvider } from '@mui/material/styles';
import MenuListComposition from './screens/MenuList';
import "./css/MenuList.css";
import "./css/Calendar.css";
import "./css/Data.css";
import CalendarView from './screens/CalendarView';
import Data from './screens/Deals';
import Technicians from './screens/Technicians';
import './App.css';
import LoginPage from './screens/loginPage';
import Profile from './screens/Profile';
// import { ThemeProvider } from '@mui/material/styles';

function App() {
  const [loggedInUser, setLoggedInUser] = useState(null);

  const handleLogin = (user) => {
    setLoggedInUser(user);
  };

  const handleLogout = () => {
    setLoggedInUser(null);
  };

  return loggedInUser ? (
    <Router>
    <div className="App">
      <React.StrictMode>
        <StyledEngineProvider injectFirst>
        {/* <ThemeProvider theme={theme}> */}
          <MenuListComposition />
          <Routes>
            <Route path="/calendar" element={<CalendarView />} />
            <Route path="/data" element={<Data />} />
            <Route path="/technicians" element={<Technicians />} />
            <Route path="/profile" element={<Profile user={loggedInUser} />} /> 
          </Routes>
        </StyledEngineProvider>
      </React.StrictMode>
    </div>
    <button onClick={handleLogout}>Logout</button>
    </Router>
  ) : (
    <LoginPage onLogin={handleLogin} />
  );
}

export default App;

